"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Popover_1 = require("../Popover");
var FontAwesomeIcon_1 = __importDefault(require("../FontAwesomeIcon"));
var PopoverButtonText_1 = __importDefault(require("./components/PopoverButtonText"));
var PopoverButtonWrapper_1 = __importDefault(require("./components/PopoverButtonWrapper"));
var PopoverButton = react_1.default.forwardRef(function (_a, ref) {
    var as = _a.as, children = _a.children, disabled = _a.disabled, icon = _a.icon, onClick = _a.onClick, textProps = _a.textProps, props = __rest(_a, ["as", "children", "disabled", "icon", "onClick", "textProps"]);
    var rtl = react_1.default.useContext(Popover_1.PopoverContext).rtl;
    return (react_1.default.createElement(PopoverButtonWrapper_1.default, __assign({ tabIndex: 0 }, props, { disabled: disabled, onClick: !disabled ? onClick : undefined, forwardedAs: as, ref: ref, rtl: rtl }),
        icon && react_1.default.createElement(FontAwesomeIcon_1.default, __assign({}, icon)),
        react_1.default.createElement(PopoverButtonText_1.default, __assign({}, textProps, { rtl: rtl }), children)));
});
PopoverButton.displayName = "PopoverButton";
exports.default = PopoverButton;
//# sourceMappingURL=index.js.map